<template>
    <v-card>
        <v-data-table
            :loading="reportTableLoading"
            :headers="headers"
            :items="hotelReportData"
            :server-items-length="total"
            :hide-default-footer="hideFooter"
            :options.sync="options"
            :footer-props="getFooterProps()"
        >
            <template v-slot:item.avgBookedDays="{item}">
                {{ parseFloat(item.avgBookedDays).toFixed(1) }}
            </template>
            <template v-slot:item.avgDailyRate="{item}">
                {{ getValueInReais(item.avgDailyRate) }}
            </template>
            <template v-slot:item.totalValue="{item}">
                {{ getValueInReais(item.totalValue) }}
            </template>
            <template v-slot:item.manualBookingsPercentage="{item}">
                {{ formatPercentage(item.manualBookingsPercentage) }}
            </template>
            <template v-slot:item.automaticBookingsPercentage="{item}">
                {{ formatPercentage(item.automaticBookingsPercentage) }}
            </template>
            <template v-slot:item.confirmedBookingsPercentage="{item}">
                {{ formatPercentage(item.totalConfirmedBookingsPercentage) }}
            </template>
            <template v-slot:item.totalCanceledBookingsPercentage="{item}">
                {{ formatPercentage(item.totalCanceledBookingsPercentage) }}
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    name: "HotelReportTable",

    props: {
        limit: {
            type: Number,
            default: null,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        hideQuery: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        hotelReportData: [],
        reportTableLoading: true,
        total: 0,
        query: '',
        filter: {},
        queryFilter: {},
        options: {
            sortDesc: [true],
        },
        headers: [
            {text: 'Hotel', value: 'hotel.name', sortable: false},
            {text: 'Cidade', value: 'hotel.city', sortable: false},
            {text: 'Estado', value: 'hotel.state', sortable: false},
            {text: 'Reservas finalizadas', value: 'hotelBookings', width: '10%', sortable: true},
            {text: 'Reservas canceladas', value: 'totalCanceledBookings', width: '10%', sortable: true},
            {text: 'Diárias (média)', value: 'avgBookedDays', sortable: true},
            {text: 'Valor da Diária (média)', value: 'avgDailyRate', sortable: true},
            {text: 'Valor Total', value: 'totalValue', width: '12%', sortable: true},
            {text: 'Fin. Automáticas', value: 'automaticBookingsPercentage', sortable: true},
            {text: 'Fin. Manuais', value: 'manualBookingsPercentage', sortable: true},
            {text: '% de Conf.', value: 'confirmedBookingsPercentage', sortable: true},
            {text: '% de Cancel.', value: 'totalCanceledBookingsPercentage', sortable: true},
        ]
    }),

    methods: {
        formatPercentage(value) {
            if (value !== null) {
                return parseFloat(value).toFixed(2) + '%';
            }
            return '0.00%';
        },

        getValueInReais(value) {
            return 'R$ ' + (value / 100).toFixed(2);
        },

        setFilter(filter) {
            this.filter = {
                'hotelName': filter.hotelName ?? '',
                'hotelCity': filter.hotelCity ?? '',
                'hotelState': filter.hotelState ?? '',
                'createdStartDate': filter.createdStartDate ?? '',
                'createdUntilDate': filter.createdUntilDate ?? '',
                'bookingStartDate': filter.bookingStartDate ?? filter.startDate ?? '',
                'bookingUntilDate': filter.bookingUntilDate ?? filter.finalDate ?? '',
            };
        },

        setQueryString() {
            this.query = `sortBy=${this.options.sortBy}&page=${this.options.page}&sortDesc=${this.options.sortDesc}&perPage=${this.options.itemsPerPage}&limit=${this.limit ?? ''}`+
                `&hotelName=${this.filter.hotelName}&hotelCity=${this.filter.hotelCity}&hotelState=${this.filter.hotelState}` +
                `&createdStartDate=${this.filter.createdStartDate}&createdUntilDate=${this.filter.createdUntilDate}` +
                `&bookingStartDate=${this.filter.bookingStartDate}&bookingUntilDate=${this.filter.bookingUntilDate}`;
        },

        pushQueryToRouter() {
            if (!this.hideQuery) {
                this.$router.push({
                    query: {
                        'page': this.options.page,
                        'perPage': this.options.itemsPerPage,
                        'sortBy': this.options.sortBy,
                        'sortDesc': this.options.sortDesc,
                        'hotelName': this.filter.hotelName,
                        'hotelCity': this.filter.hotelCity,
                        'hotelState': this.filter.hotelState,
                        'createdStartDate': this.filter.createdStartDate,
                        'createdUntilDate': this.filter.createdUntilDate,
                        'bookingStartDate': this.filter.bookingStartDate,
                        'bookingUntilDate': this.filter.bookingUntilDate,
                    }
                });
            }
        },

        getReportData(filter = {}) {
            this.reportTableLoading = true;
            this.setFilter(filter);
            this.setQueryString();
            this.pushQueryToRouter();
            axios.get(`/api/reports/hotel?${this.query}`)
                .then(res => {
                    this.hotelReportData = res.data.data;
                    this.total = res.data.total;
                    this.reportTableLoading = false;
                });
        },

        getFooterProps() {
            if (this.hideFooter) {
                return {itemsPerPageOptions: [30]};
            }
            return {itemsPerPageOptions: [10, 15, 30]};
        },

        getOptionsFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    page,
                    perPage,
                    sortBy,
                    sortDesc,
                } = this.$route.query;
                if (page) {
                    this.options.page = parseInt(page ? page : 1);
                }
                if (perPage) {
                    this.options.itemsPerPage = perPage;
                }
                if (sortBy) {
                    this.options.sortBy = sortBy;
                }
                if (sortDesc) {
                    this.options.sortDesc = sortDesc;
                }
            }
        },
    },

    mounted() {
        this.getOptionsFromUrlQuery();
    },

    watch: {
        options: {
            handler: function() {
                if (!this.hideQuery) {
                    this.getReportData(this.filter);
                }
            },
            deep: true
        },
    }
}
</script>

<style scoped>
.hotel-list-header {
    border-radius: 4px 4px 0 0;
}
</style>
